import { cn } from '@latitude/token-utils';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import React from 'react';
import type { Ref } from 'react';

const CollapsibleRoot = CollapsiblePrimitive.Root;

const CollapsibleContent = ({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<
  typeof CollapsiblePrimitive.CollapsibleContent
> & {
  ref?: Ref<React.ComponentRef<typeof CollapsiblePrimitive.CollapsibleContent>>;
}) => (
  <CollapsiblePrimitive.CollapsibleContent
    ref={ref}
    className={cn(
      'data-[state=open]:animate-collapsible-down data-[state=closed]:animate-collapsible-up overflow-hidden',
      className,
    )}
    {...props}
  />
);

CollapsibleContent.displayName = 'CollapsibleContent';

type CollapsibleProps = {
  open?: boolean;
  setOpen?: (open: boolean) => void;
  children: React.ReactNode;
};

const Collapsible = ({
  open,
  children,
  ref,
}: CollapsibleProps & {
  ref?: Ref<React.ComponentRef<typeof CollapsiblePrimitive.CollapsibleContent>>;
}) => {
  return (
    <CollapsibleRoot open={open}>
      <CollapsibleContent ref={ref}>{children}</CollapsibleContent>
    </CollapsibleRoot>
  );
};

Collapsible.displayName = 'Collapsible';

export { Collapsible };
